<template>
  <div class="container max-w-lg bg-white p-6 shadow-lg">
    <app-badge
      :icon="isActive ? 'check' : 'close-circle'"
      :type="isActive ? 'positive' : 'negative'"
    >
      {{ companiesHouse.company_status | sentencecase }}
    </app-badge>
    <h2 class="text-xl">
      {{ company.name | sentencecase }} [{{ company.number }}]
    </h2>
    <p
      v-if="companiesHouse.date_of_cessation"
      class="text-sm font-bold text-negative-800"
    >
      Dissolved on: {{ formatDate(companiesHouse.date_of_cessation) }}
    </p>
    <p
      class="italic"
      v-html="companyAddress"
    />
    <p class="mt-2">
      <icon-link
        :href="`https://beta.companieshouse.gov.uk/company/${company.number}`"
        target="_blank"
        rel="noopener"
        icon="external-window"
      >
        Companies House
      </icon-link>
    </p>
    <div class="flex flex-wrap my-12 -mx-6">
      <div class=" w-full md:w-1/2 px-6">
        <app-badge
          v-if="accounts.overdue"
          icon="close-circle"
          type="negative"
        >
          Overdue
        </app-badge>
        <h3 class="mb-2">
          Accounts
        </h3>
        <p class="mb-2">
          Next accounts made up to <strong>{{ formatDate(accounts.next_made_up_to) }}</strong> due by <strong>{{ formatDate(accounts.next_due) }}</strong>.
        </p>
        <p v-if="!accounts.last_accounts.type">
          Last accounts made up to <strong>{{ formatDate(accounts.last_accounts.made_up_to) }}</strong>.
        </p>
      </div>
      <div
        v-if="confirmation_statement"
        class="w-full md:w-1/2 px-6"
      >
        <app-badge
          v-if="confirmation_statement.overdue"
          icon="close-circle"
          type="negative"
        >
          Overdue
        </app-badge>
        <h3 class="mb-2">
          Confirmation statement
        </h3>
        <p class="mb-2">
          Next statement date <strong>{{ formatDate(confirmation_statement.next_made_up_to) }}</strong> due by <strong>{{ formatDate(confirmation_statement.next_due) }}</strong>.
        </p>
        <p>Last statement dated <strong>{{ formatDate(confirmation_statement.last_made_up_to) }}</strong>.</p>
      </div>
    </div>
    <div v-if="SICValue">
      <h3 class="mt-4">
        Nature of business (SIC)
      </h3>
      <p v-html="SICValue" />
    </div>
  </div>
</template>

<script>
import { SIC } from '../../store/sic'
import pick from 'lodash/pick'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
export default {
  name: 'UserCompany',
  computed: {
    companiesHouse() {
      return JSON.parse(this.company.companies_house_info)
    },
    company() {
      return this.state.profile.company
    },
    companyAddress() {
			let address = pick(this.company, [
				'address_line_1',
				'address_line_2',
				'town',
				'county',
				'postcode'
			]);
			return Object.values(address).filter(Boolean).join('<br>');
    },
    accounts() {
      return this.companiesHouse.accounts || false
    },
    confirmation_statement() {
      return this.companiesHouse.confirmation_statement || false
    },
    isActive() {
      return this.companiesHouse.company_status === 'active';
    },
    SICValue() {
      const company_sic = this.companiesHouse.sic_codes;
      const sic = SIC;
      if( !company_sic ) return;
      return company_sic.reduce((arr, code) => {
        arr.push(`<strong>${code}</strong>: ${sic.code(code)}`)
        return arr
      }, []).join('<br>')
    }
  },
  methods: {
    formatDate(date) {
      return format(parseISO(date), 'do MMMM yyyy')
    }
  }
}
</script>
